export default __webpack_public_path__ + "static/media/saurabhgupta.8b7d986a.png";